<template>
  <v-container fluid>
    <v-card class="pa-4" >
      <v-toolbar flat color="primary" dark>
        <v-icon class="mr-2">mdi-eye</v-icon>
        Acompanhar Turma - Visualizar
        <v-spacer />
      </v-toolbar>
      <div v-if="turma">
        <div class="my-3 pa-4" style="border: 1px solid #ccc; border-radius: 8px;">
          <DadosProfissionaisComponent
          v-for="(professor) in turma.professores"
          :key="professor.id"
          :profissional="professor"
          />
          <v-divider class="my-4"/>
          <ProfissionaisPorFuncaoComponent
            v-if="turma.articuladoresRegionais"
            :funcao="'Articulador Regional'"
            :profissionais="turma.articuladoresRegionais"
          />
          <ProfissionaisPorFuncaoComponent
            v-if="turma.articuladoresMunicipais"
            :funcao="'Articulador Municipal'"
            :profissionais="turma.articuladoresMunicipais"
          />
        </div>
    
        <DadosDaTurmaComponent :turma="turma" />
  
        <v-tabs v-model="abaSelecionada" class="mt-4">
          <v-tab v-for="bimestre in bimestres" :key="bimestre">
            {{ bimestre }}º Bimestre
          </v-tab>
        </v-tabs>
  
        <v-tabs-items v-model="abaSelecionada">
          <v-tab-item v-for="bimestre in turma.bimestres" :key="bimestre.numero">
            <v-expansion-panels multiple>
              <v-expansion-panel
                v-for="(perfisTurma, nomePerfil) in bimestre.perfis"
                :key="nomePerfil"
                class="mt-2"
              >
                <v-expansion-panel-header class="font-weight-bold text-subtitle-1">
                  Perfil da Turma em {{ nomePerfil }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-data-table
                    :headers="lists.headerPerfis"
                    :items="perfisTurma"
                    class="elevation-1"
                    hide-default-footer
                  ></v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel
                v-for="(habilidadesTurma, nomeHabilidade) in bimestre.habilidades"
                :key="nomeHabilidade"
                class="mt-2"
              >
                <v-expansion-panel-header class="font-weight-bold text-subtitle-1">
                {{ nomeHabilidade }}
                </v-expansion-panel-header>
                <v-expansion-panel-content class="px-4">
                  <v-data-table
                    :headers="lists.headerHabilidades"
                    :items="habilidadesTurma"
                    class="elevation-1"
                    hide-default-footer
                  ></v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-tab-item>
        </v-tabs-items>
      </div>
      <div v-if="semPermissao" class="mt-4 pa-4">
        <v-alert type="error">
          Você não tem permissão para visualizar o acompanhamento desta turma.
        </v-alert>
      </div>

      <v-card-actions>
        <v-btn class="mt-4" outlined color="primary" @click="voltar">
          <v-icon left>mdi-arrow-left</v-icon>
          Voltar
        </v-btn>
      </v-card-actions>

      
    </v-card>
  </v-container>
</template>

<script>
import AcompanhamentoDeTurmasService from '~/services/acompanhamento-de-turmas.service';
import DadosProfissionaisComponent from '~/components/DadosProfissionaisComponent.vue';
import ProfissionaisPorFuncaoComponent from './components/ProfissionaisPorFuncaoComponent.vue';
import DadosDaTurmaComponent from './components/DadosDaTurmaComponent.vue';

export default {
  name: 'VisualizarAcompanhamentoDeTurmasAdministracaoView',
  components: {
    DadosProfissionaisComponent, ProfissionaisPorFuncaoComponent, DadosDaTurmaComponent
  },
  mixins: [AcompanhamentoDeTurmasService],
  data() {
    return {
      semPermissao: false,
      turma: null,
      bimestres: [1,2,3,4],
      abaSelecionada: 0,
      lists: {
        headerPerfis: [
          { text: 'Perfil', value: 'nome' , sortable: false, align: 'left', width: '60%'},
          { text: 'Quantidade de estudantes', value: 'quantidadeAlunos' , sortable: false, align: 'center', width: '20%'},
          { text: 'Percentual de estudantes em relação à turma', value: 'percentualDaTurma', sortable: false, align: 'right', width: '20%' }
        ],
        headerHabilidades: [
          { text: 'Habilidade', value: 'nome', class:'text-wrap', align: 'center', cellClass: 'text-wrap', sortable: false },
          { text: 'Código da Habilidade', value: 'codigo', class:'text-wrap', align: 'center', cellClass: 'text-wrap', sortable: false },
          { text: 'Não Desenvolveu', value: 'naoDesenvolveu', class:'text-wrap', align: 'center', cellClass: 'text-wrap', sortable: false },
          { text: 'Percentual', value: 'percentualNaoDesenvolveu', class:'text-wrap', align: 'right', cellClass: 'text-wrap', sortable: false },
          { text: 'Desenvolveu Parcialmente', value: 'desenvolveuParcialmente', class:'text-wrap', align: 'center', cellClass: 'text-wrap', sortable: false },
          { text: 'Percentual', value: 'percentualDesenvolveuParcialmente', class:'text-wrap', align: 'right', cellClass: 'text-wrap', sortable: false },
          { text: 'Desenvolveu', value: 'desenvolveu', class:'text-wrap', align: 'center', cellClass: 'text-wrap', sortable: false },
          { text: 'Percentual', value: 'percentualDesenvolveu', class:'text-wrap', align: 'right', cellClass: 'text-wrap', sortable: false },
        ]
      }
    };
  },
  computed: {
    bimestreSelecionado() {
      return this.turma.bimestres.find(b => b.numero === this.bimestreSelecionado) || {};
    }
  },

  methods: {
    voltar() {
      this.$router.push({ name: "Acompanhamento de Turmas - :cargo" });
    },
  },
  mounted() {
    const id = this.$route.params.id;

    this.$visualizarAdministracao(id).then(({ data }) => {
      this.turma = data.resposta;
    }).catch((error) => {
      this.semPermissao = error?.response?.data?.naoTemPermissao || false;
    });
  },
};
</script>